import { useContext } from 'react';
import { InstantCheckoutContext } from '../contexts/instant-checkout-context';
export const useInstantCheckout = () => {
    const context = useContext(InstantCheckoutContext);
    if (!context) {
        throw new Error('useInstantCheckoutContext must be used within a useInstantCheckoutProvider');
    }
    return context;
};
